class SideMenu {
  el;
  buttonOpen;
  buttonClose;
  siteHeader;
  originalTheme;
  backdrops;
  body;


  constructor(sideMenu) {
    this.el = sideMenu;
    this.buttonOpen = document.querySelector(".button-side-menu");
    this.buttonClose = document.querySelector(".button-close");
    this.backdrops = document.querySelectorAll(".backdrop");
    this.siteHeader = document.getElementById("site-header");
    this.body = document.body;


    if (this.siteHeader.classList.contains("theme-dark")) {
      this.originalTheme = "theme-dark";
    } else if (this.siteHeader.classList.contains("theme-light")) {
      this.originalTheme = "theme-light";
    } else if (this.siteHeader.classList.contains("theme-yellow")) {
      this.originalTheme = "theme-yellow";
    }

    this.bindListeners();
  }

  bindListeners() {
    this.buttonOpen.addEventListener("click", this.open.bind(this));
    this.buttonClose.addEventListener("click", this.close.bind(this));
    window.addEventListener("scroll", this.handleScroll.bind(this));
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > 0) {
      if (this.siteHeader) {
        this.siteHeader.classList.add("is-scrolling");
      }
      if (this.siteHeader.classList.contains("theme-dark")) {
        this.siteHeader.classList.remove("theme-dark");
        this.siteHeader.classList.add("theme-light");
      }
      if (this.siteHeader.classList.contains("theme-yellow")) {
        this.siteHeader.classList.remove("theme-dark");
        this.siteHeader.classList.add("theme-light");
      }
    }
  }

  handleScroll() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (scrollTop > 0) {
      if (this.siteHeader) {
        this.siteHeader.classList.add("is-scrolling");
      }
      if (this.siteHeader.classList.contains("theme-dark")) {
        this.siteHeader.classList.remove("theme-dark");
        this.siteHeader.classList.add("theme-light");
      }
      if (this.siteHeader.classList.contains("theme-yellow")) {
        this.siteHeader.classList.remove("theme-dark");
        this.siteHeader.classList.add("theme-light");
      }
    } else {
      this.siteHeader.classList.remove("theme-dark", "theme-light", "is-scrolling");
      this.siteHeader.classList.add(this.originalTheme);
    }
  }

  open() {
    this.el.style.transition = "";
    this.el.classList.remove("closing");
    this.body.classList.add("no-scroll");
    this.el.classList.add("open");
    this.el.style.opacity = "1";
    this.siteHeader.classList.add("is-open");
    this.buttonOpen.setAttribute("aria-expanded", "true");
    this.backdrops.forEach(backdrop => {
      backdrop.classList.add("active");
    })


    if (this.originalTheme === "theme-dark") {
      this.siteHeader.classList.remove("theme-dark");
      this.siteHeader.classList.add("theme-light");
    }

    const evento = {
      event: 'click_menuMobile',
      item_action: 'Open'
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
  }

  close() {
    this.el.style.transition = "height .5s linear 1.5s";
    this.el.classList.add("closing");

    setTimeout(() => {
      const realHeight = this.el.offsetHeight;
      this.el.style.height = `${realHeight}sh`;
    }, 1500);

    setTimeout(() => {
      this.el.classList.remove("closing");
    }, 2000);


    this.body.classList.remove("no-scroll"); 
    this.el.classList.remove("open");
    this.backdrops.forEach(backdrop => {
      backdrop.classList.remove("active");
    });
  
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (this.originalTheme === "theme-dark") {
      if (scrollTop === 0) {
        setTimeout(() => {
          this.siteHeader.classList.remove("theme-light");
          this.siteHeader.classList.add("theme-dark");
        }, 1800);
      }
    }

    if (this.originalTheme === "theme-yellow") {
      if (scrollTop === 0) {
        setTimeout(() => {
          this.siteHeader.classList.remove("theme-light");
          this.siteHeader.classList.add("theme-yellow");
        }, 1800);
      }
    }

    if (this.originalTheme === "theme-dark" || this.originalTheme === "theme-light" || this.originalTheme === "theme-yellow") {
      setTimeout(() => {
        this.siteHeader.classList.remove("is-open");
      }, 1800);
    }
    
    const evento = {
      event: 'click_menuMobile',
      item_action: 'Close'
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
  }
}

const sideMenu = document.querySelector(".js-side-menu");
if (sideMenu) {
  new SideMenu(sideMenu);
}

class MenuAnalytics {
  els;

  constructor(menuItems) {
    this.els = menuItems;
    this.bindListeners();
  }

  bindListeners() {
    this.els.forEach((menuItem) => {
      menuItem.addEventListener("click", this.dataPush.bind(this));
    })
  }

  dataPush(e) {
    e.preventDefault();

    const href = e.target.href;
    const dataName = e.target.innerHTML;
    const evento = {
      event: 'click_menu',
      item_nombre: dataName
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
    setTimeout(() => {
      window.location.href = href;
    }, 200);
  }
}

class LangAnalytics {
  els;

  constructor(langItems) {
    this.els = langItems;
    this.bindListeners();
  }

  bindListeners() {
    this.els.forEach((menuItem) => {
      menuItem.addEventListener("click", this.dataPush.bind(this));
    })
  }

  dataPush(e) {
    e.preventDefault();

    const oldLang = document.querySelector('.language-selector__button').innerHTML;
    const newLang = e.target.innerHTML;
    const href = e.target.href;
    
    const evento = {
      event: 'click_idioma',
      item_previous: oldLang,
      item_next: newLang
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(evento);
    //console.log('Evento enviado al dataLayer:', evento);
    
    setTimeout(() => {
      window.location.href = href;
    }, 200);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const menuItems = document.querySelectorAll('#site-header .menu-item > a');
  const sidemenuItems = document.querySelectorAll('#side-menu .menu-item > a');
  const langItems = document.querySelectorAll('.language-selector a');
  if(menuItems.length > 0) {
    new MenuAnalytics(menuItems);
  }
  if(sidemenuItems.length > 0) {
    new MenuAnalytics(sidemenuItems);
  }
  if(langItems.length > 0) {
    new LangAnalytics(langItems);
  }
});

